import React, { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import routes from 'config/config/routes';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	NavigationWrapper,
	PickerHOC,
	TargetsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import BackNextButton from 'components/BackNextButton/BackNextButton';
import InputLabel from 'components/InputLabel/InputLabel';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { OptionButton } from 'components/OptionButton/OptionButton';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { cleanIBANNumber, isValidIBANNumber } from 'helpers/Iban';

import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import * as S from './styles';

export const BankAccount = PickerHOC(
	{
		target: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
			arrayItemMatcher: {
				type: 'param',
				paramName: 'targetId',
				itemPropertyPath: 'id',
			},
		},
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
	},
	LoadingScreen,
)(() => {
	const { useHeader, useFooter, useLoading } = UiWrapper.use();
	const { navigateTo, goBack } = NavigationWrapper.use();
	const { saveTargetProperty } = TargetsWrapper.use();
	const { target, user } = PickerHOC.use();
	const { t, i18n } = useTranslation();

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('BankAccount');

	// TARGET CREATION DATA
	const creationData = useMemo(
		() => target?.targetProperties?.find((x) => x.name === 'creationData')?.value,
		[target],
	);

	// ESTADO
	const [chargeAccount, setChargeAccount] = useState(creationData?.chargeAccount || '');
	const [ownChargeAccount, setOwnChargeAccount] = useState(
		creationData?.ownChargeAccount || undefined,
	);
	const [ibanError, setIbanError] = useState(false);

	// NAVIGATION
	const next = async () => {
		await saveTargetProperty(target.id, 'creationData', {
			...creationData,
			chargeAccount: chargeAccount.replace(/\s+/g, ''),
			ownChargeAccount,
		});

		if (ownChargeAccount === false) {
			CONFIG.routing.bankAccount.ko(navigateTo);
		} else {
			CONFIG.routing.bankAccount.next(navigateTo);
		}
	};

	const isDisabled = () => {
		return !chargeAccount || ibanError || ownChargeAccount === undefined;
	};

	// EFFECTS
	useEffect(() => {
		console.log('📌 user', user);
		console.log('📌 creationData', creationData);
		return () => { };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Wrapper
			showTopSection
			step={4}
			title="Banco"
			subtitle="Esta será la cuenta bancaria asociada a tu seguro de vida y en la que se te pasará el recibo."
		>
			<View innerWrapperSt>
				<InputLabel
					type="custom"
					style={{
						marginTop: -20,
					}}
					label={'IBAN'}
				>
					<View rowSt justifyStartSt>
						<S.IbanInput
							maxLength="24"
							placeholder="ESXX XXXX XXXX XXXX XXXX XXXX"
							value={chargeAccount}
							onChange={(e) => {
								if (ibanError) {
									setIbanError(false);
								}
								setChargeAccount(cleanIBANNumber(e.target.value.toUpperCase()));
							}}
							onBlur={() => {
								const validateIban = isValidIBANNumber(chargeAccount);
								setIbanError(validateIban !== 1);
							}}
						/>
						{/* <CloseIcon
							onClick={() => {
								setIbanError(false);
								setChargeAccount('');
							}}
							style={{
								marginLeft: 5,
								color: CONFIG.colors.danger,
								cursor: 'pointer',
								visibility: chargeAccount ? 'visible' : 'hidden',
							}}
						/> */}
					</View>
				</InputLabel>

				{ibanError && <Text errorInputSt>Por favor introduce un IBAN válido</Text>}
				<Text smSt style={{ marginTop: 10 }}>
					Introducir manualmente el nº de cuenta
				</Text>
				<View inputFreeRowSt>
					<InputLabel
						label={'Declaro que la cuenta introducida es de mi titularidad'}
						type="custom"
					>
						<View
							rowSt
							justifyStartSt
							style={{
								gap: isMobile ? '20px' : '12px',
								flexWrap: 'wrap',
							}}
						>
							<OptionButton
								onClick={() => setOwnChargeAccount(true)}
								selected={ownChargeAccount === true}
								text={'Sí'}
								style={{
									width: isMobile ? '100%' : undefined,
									margin: isMobile ? 0 : undefined,
								}}
							/>
							<OptionButton
								onClick={() => setOwnChargeAccount(false)}
								selected={ownChargeAccount === false}
								text={'No'}
								style={{
									width: isMobile ? '100%' : undefined,
									margin: isMobile ? 0 : undefined,
								}}
							/>
						</View>
					</InputLabel>
				</View>
			</View>
			<BackNextButton
				onClickBack={() =>
					navigateTo(routes.clientData, { queryParams: { internalStep: 4 } })
				}
				onClickNext={next}
				isNextDisabled={isDisabled()}
			/>
		</Wrapper>
	);
});
